import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BottomSheet from '../BottomSheet';
import { SelectField, TextField } from '../FormFields';

const ShareLinkModal = ({ shareLink, isGenerating = false, onGenerate, onClose }) => {
  const [copyStatus, setCopyStatus] = useState('');
  const [role, setRole] = useState('editor');

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareLink);
      setCopyStatus('Link copiado.');
    } catch (error) {
      setCopyStatus('Não foi possível copiar o link.');
    }
  };

  const handleGenerate = async () => {
    setCopyStatus('');
    try {
      await onGenerate(role);
    } catch (error) {
      // O feedback global é exibido pela Dashboard e o sheet permanece aberto.
    }
  };

  return (
    <BottomSheet
      title="Compartilhar acesso"
      subtitle="Crie um convite temporário para uma pessoa de confiança."
      onClose={onClose}
      size="sm"
      footer={shareLink ? (
        <>
          <button type="button" className="nf-sheet__primary" onClick={handleCopy}>Copiar link</button>
          <button type="button" className="nf-sheet__secondary" onClick={onClose}>Fechar</button>
        </>
      ) : (
        <>
          <button type="button" className="nf-sheet__primary" onClick={handleGenerate} disabled={isGenerating}>
            {isGenerating ? 'Criando convite…' : 'Criar convite'}
          </button>
          <button type="button" className="nf-sheet__secondary" onClick={onClose} disabled={isGenerating}>Cancelar</button>
        </>
      )}
    >
      {!shareLink ? (
        <SelectField
          id="share-access-role"
          label="Permissão"
          hint="Editor pode alterar finanças; visualizador possui somente leitura."
          value={role}
          onChange={setRole}
          disabled={isGenerating}
        >
          <option value="editor">Editor</option>
          <option value="viewer">Visualizador</option>
        </SelectField>
      ) : (
        <TextField id="share-access-link" label="Link de compartilhamento" value={shareLink} readOnly />
      )}
      {copyStatus && <p className="nf-sheet-copy-status" role="status">{copyStatus}</p>}
    </BottomSheet>
  );
};

ShareLinkModal.propTypes = {
  shareLink: PropTypes.string.isRequired,
  isGenerating: PropTypes.bool,
  onGenerate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};


export default ShareLinkModal;
